import { Reveal, Overline } from "@/components/site/Reveal";
import { ASSETS } from "@/lib/content";

const STATS = [
  { k: "Mom of 3", v: "Leading her most important team" },
  { k: "Founder", v: "Ed-tech company, later acquired" },
  { k: "BCBA-D", v: "Doctoral-level Board Certified Behavior Analyst" },
  { k: "PhD", v: "Education & ABA, Columbia University" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about"
      className="relative py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-7">
          <Reveal>
            <Overline>About Dr. Joanne</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <p className="mt-8 font-serif text-3xl md:text-5xl font-light leading-[1.15] tracking-tight">
              <span className="text-primary text-6xl md:text-8xl font-serif leading-none float-left mr-4 -mt-2">
                “
              </span>
              I believe behavioral science belongs wherever people are learning,
              leading, growing, and building something that matters.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-10 max-w-2xl space-y-6 text-lg leading-relaxed text-muted-foreground">
              <p>
                My mission is simple: to partner with leaders, organizations,
                professionals, and families to intentionally design environments
                where everyone can flourish.
              </p>
              <p>
                I'm Dr. Joanne Hill Powell — a certified teacher, doctoral-level
                behavior analyst, entrepreneur, executive leader, wife, and proud
                mom of three. My career has taken me from classrooms and
                universities to startups and boardrooms, with experience spanning
                applied behavior analysis, organizational leadership, business
                development, professional learning, and family-centered support.
              </p>
              <p>
                Along the way, I've discovered that while the settings may change,
                the principles remain remarkably consistent. Whether supporting an
                executive leading an organization, a founder building a company, an
                educator shaping a classroom, or a parent raising a child,
                meaningful growth begins with intentionally designing environments
                that support learning, connection, and measurable progress.
              </p>
              <p>
                Throughout my career, I've had the privilege of helping
                professionals translate expertise into influence, organizations
                transform ideas into sustainable solutions, educators strengthen
                learning environments, and families build the confidence and skills
                to navigate life's opportunities and challenges together.
              </p>
              <p>
                Above all, my greatest leadership lessons haven't come from a
                boardroom or a classroom — they've come from the privilege of
                building a life alongside my husband and raising our three children.
                Every day reminds me that leadership is not simply about achieving
                results; it's about creating the conditions where people feel seen,
                supported, challenged, and inspired to become the very best version
                of themselves.
              </p>
            </div>
          </Reveal>

          <div className="mt-14 grid sm:grid-cols-2 gap-x-10 gap-y-8">
            {STATS.map((s, i) => (
              <Reveal key={s.k} delay={0.05 * i}>
                <div className="border-t border-border pt-5">
                  <p className="font-serif text-2xl md:text-3xl font-light">
                    {s.k}
                  </p>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                    {s.v}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <Reveal delay={0.1}>
            <div className="relative">
              <div className="overflow-hidden rounded-2xl">
                <img
                  src={ASSETS.standingPortrait}
                  alt="Dr. Joanne Hill Powell"
                  className="w-full object-cover aspect-[4/5]"
                />
              </div>
              <div className="absolute -top-5 -right-4 rounded-full bg-primary text-primary-foreground px-6 py-6 text-center rotate-6">
                <p className="font-serif text-xl leading-none">💗</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
